import { Head, Link, useForm } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"

export default function VerifyEmailChange({ valid, pendingEmail, token }) {
  return (
    <>
      <Head title="Confirm email change" />
      <div className="min-h-screen bg-zinc-50 px-4 py-12">
        <div className="mx-auto max-w-md">
          {valid ? (
            <ValidConfirm pendingEmail={pendingEmail} token={token} />
          ) : (
            <InvalidLink />
          )}
        </div>
      </div>
    </>
  )
}

function ValidConfirm({ pendingEmail, token }) {
  const form = useForm({ key: token })

  const submit = (event) => {
    event.preventDefault()
    form.post("/verify-email-change")
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Confirm your new email</CardTitle>
        <CardDescription>
          Click the button below to switch your sign-in email to{" "}
          <span className="font-medium text-zinc-900">{pendingEmail}</span>.
          You&rsquo;ll be signed out of all devices and will sign back in with the new email.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={submit} className="space-y-4">
          <input type="hidden" name="key" value={token} readOnly />
          <Button type="submit" className="w-full" disabled={form.processing}>
            {form.processing ? "Confirming..." : "Confirm new email"}
          </Button>
        </form>
      </CardContent>
    </Card>
  )
}

function InvalidLink() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>This link is no longer valid</CardTitle>
        <CardDescription>
          Email-change links expire after 24 hours, and each link can only be used once. Sign in
          with your current email and request a new change from your account page.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button asChild className="w-full">
          <Link href="/login">Go to sign in</Link>
        </Button>
      </CardContent>
    </Card>
  )
}
